import "./Footer.css";

export default function FooterTemplate() {
  return (
    <footer className="footer">
      <div className="footer__inner">

        <div className="footer__logo">
          <div className="footer__logo-icon">⚡</div>
          <span className="footer__logo-text">
            QuickWork<span className="footer__logo-accent">.ro</span>
          </span>
        </div>

        <p className="footer__copy">
          © 2025 QuickWork.ro - Automatizare pentru firme din România.
        </p>

        <div className="footer__links">
          <span className="footer__link">contact@quickwork.ro</span>
        </div>

      </div>
    </footer>
  );
}
